import VueRouter from "vue-router";
import Vue from "vue";
import axios from "axios";
import routes from "./router.js";

// 解决重复点击菜单会报错的bug
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const router = new VueRouter({
  // mode: 'history', //history模式需要服务器配置，不然页面访问不了
  routes,
});

const homePage = "/home";
const ysSessCookieName = "YISHOUSESS";

// 判断是否登录
router.beforeEach((to, from, next) => {
  // 判断域名重定向
  // 背景：erp是hash模式，本想着将erp旧域名重定向到新域名遇到两个问题：
  // 1. nginx location 匹配 /erp/的话，接口也会被重定向，于是宽松匹配为 /erp/#/
  // 2. 但是宽松后的匹配由于浏览器不会发送到服务端（上图），因此仍然无法重定向
  // 预发布 https://erpprepublish.yishouapp.com:9091/ => https://erpweb-prepublish.yishouapp.com/
  // 生产 https://erp.yishouapp.com/ => https://erpweb.yishouapp.com/
  if (
    window.location.hostname === "erp.yishouapp.com" ||
    window.location.hostname === "erpprepublish.yishouapp.com"
  ) {
    let host = "";
    switch (process.env.NODE_ENV) {
      case "staging":
        host = "erpweb-prepublish.yishouapp.com";
        break;
      case "production":
        host = "erpweb.yishouapp.com";
        break;
      default:
        break;
    }
    const oldUrl = window.location.href;
    const url = new URL(oldUrl);
    url.host = host;
    url.port = "";
    window.location.replace(url);
  }

  const cookie = Vue.cookie.get(ysSessCookieName);
  // 检查cookie是否有用
  if (to.meta.requireAuth || new RegExp(`^${homePage}`).test(to.fullPath)) {
    // 判断该路由是否需要登录权限, uri里面有 /home前缀的也要强制登陆
    if (cookie) {
      // 通过vuex state获取当前的token是否存在
      next();
    } else {
      next({
        path: "/",
        query: {
          redirect: to.fullPath,
        }, // 将跳转的路由path作为参数，登录成功后跳转到该路由
      });
    }
  } else if (to.name === "login" && cookie) {
    const reg = new RegExp("(^|&)" + "returnUrl" + "=([^&]*)(&|$)", "i");
    const r = window.location.hash.substr(3).match(reg);
    if (r !== null) {
      // 同步检查cookie是否有效
      (async () => {
        const a = await axios.get("/erp/Admin/checkLogin");
        // 200表示cookie是有效的, 直接跳转. 否则就直接去登录页面
        if (Number(a.data.code) === 200) {
          window.location.href = unescape(r[2]);
        } else {
          // 清除cookie
          Vue.cookie.delete(ysSessCookieName);
          next();
        }
      })();
    } else {
      next(homePage);
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js